module.exports = __webpack_public_path__ + "img/MESIBAG.4572f209.jpg";